<template>
  <section class="homepage-categories">
    <Heading
      id="homepage-categories"
      tag="span"
      size="md"
      class="homepage-categories__heading"
      font-weight="regular"
      spaces-bottom
    >
      Beliebte Kategorien
    </Heading>
    <DraggableScroller
      class="homepage-categories__list-wrapper"
      has-pagination
      show-single-active-pagination
      use-list
      aria-labelledby="homepage-categories"
    >
      <li
        v-for="category in categories"
        :key="category.label"
        class="homepage-categories__list-entry"
      >
        <LinkButton
          :to="category.link"
          tag="nuxt-link"
          no-styling
          class="homepage-categories__list-item"
        >
          <CdnImage
            :src="category.image"
            class="homepage-categories__category-image"
            sizes="sm:120px xs:100vw lg:50vw"
            lazy
          />
          <Heading
            tag="span"
            font-weight="regular"
            align="center"
            class="homepage-categories__category-label"
          >
            {{ category.label }}
          </Heading>
        </LinkButton>
      </li>
    </DraggableScroller>
  </section>
</template>

<script lang="ts" setup>
import { Heading, LinkButton } from '@i22/td-longtail-vue-components';
import CdnImage from '~/components/cdn-image.vue';
import DraggableScroller from '~/components/draggable-scroller.vue';

const categories = [
  {
    label: 'Smartphones',
    image:
      '/content/content-images/new-home-page/categories/3661e81bb5d32ca590f0fd9086d6d8b1/kategorie-smartphones.png',
    link: '/smartphones-und-handys/smartphones',
  },
  {
    label: 'Tablets',
    image:
      '/content/content-images/new-home-page/categories/a453d4af182c03a3e9dde37514aad1fb/kategorie-tablets.png',
    link: '/tablets-und-zubehoer/tablets',
  },
  {
    label: 'Kopfhörer',
    image:
      '/content/content-images/new-home-page/categories/d2aaf2f9532b7451c3cfc270ae442a9f/kategorie-korpfhorrer.png',
    link: '/zubehoer/kopfhoerer',
  },
  {
    label: 'Smartwatches',
    image:
      '/content/content-images/new-home-page/categories/f1c8c84e643d2ac96cca4004aa4e30f5/kategorie-smartwatches.png',
    link: '/wearables/smartwatches',
  },
  {
    label: 'Cases',
    image:
      '/content/content-images/new-home-page/categories/692c5aa43d6371ac0b356aeb4be4a618/kategorie-cases.png',
    link: '/zubehoer/taschen-huellen',
  },
  {
    label: 'Reduzierte Angebote',
    image:
      '/content/content-images/new-home-page/categories/a015e3c80f0ff0090deec9ecb56efa42/kategorie-angebote.png',
    link: '/zubehoer?discounted=true',
  },
  {
    label: 'Gadgets',
    image:
      '/content/content-images/new-home-page/categories/4b799d85ed00f4f1b6c88af6959cde3b/kategorie-gadgets.png',
    link: '/zubehoer/innovationen-gadgets',
  },
  {
    label: 'Schutzfolien/Schutzgläser',
    image:
      '/content/content-images/new-home-page/categories/88cc10df3359659b68d9b9da17ba1400/kategorie-folien.png',
    link: '/zubehoer/schutzfolien-schutzglaeser',
  },
];
</script>

<style lang="scss" scoped>
@use 'assets/base' as *;

.homepage-categories {
  &__heading {
    padding: 0 $grid-base;
  }

  :deep(.draggable-scroller__container) {
    display: flex;
    width: 100%;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
  }

  &__list {
    &-entry {
      padding: 4px;
      flex: 0 0 33.3333%;
      scroll-snap-align: start;

      @include mq($mq-sm) {
        flex-basis: 20%;
      }

      @include mq($mq-md) {
        flex-basis: calc(100% / 6);
      }

      @include mq($mq-lg) {
        flex: 0 1 calc(100% / 8); // Schutzgläser is a little bit longer
      }
    }

    &-item {
      color: var(--color-font);
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: $grid-base;
      padding: 0 $grid-base $grid-base;

      &:hover,
      &:focus {
        color: var(--color-font);
      }

      &:hover {
        .homepage-categories__category-image {
          transform: scale(1.1);
        }
      }
    }
  }

  &__category-image {
    transition: transform 0.3s ease;
    will-change: transform;

    :deep(img) {
      width: 120px;
      height: 165px;
      max-width: none;
    }
  }

  &__category-label {
    font-size: inherit;
    line-height: inherit;
  }
}
</style>
